import React from 'react'
import { css } from '@emotion/react'
import { VIdeoModalT } from '@lib/modal'

const WebVideoModal = ({
  videoModal,
  setVideoModal,
}: {
  videoModal: VIdeoModalT
  setVideoModal: React.Dispatch<React.SetStateAction<VIdeoModalT>>
}) => {
  return (
    <div
      css={webVideoStyle}
      onClick={() => setVideoModal({ src: '', isModal: false })}
    >
      <div className="modal_container" onClick={(e) => e.stopPropagation()}>
        <div className="modal_content">
          <div className="modal_content_box">
            <video src={videoModal.src} loop autoPlay className="modal_video" />
          </div>
        </div>
      </div>
    </div>
  )
}
const webVideoStyle = () => css`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 3;
  .modal_container {
    width: 1100px;
    height: 621px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .modal_content {
      position: relative;
      width: 100%;
      height: 100%;
      svg {
        z-index: 1;
        cursor: pointer;
        position: absolute;
        top: 16px;
        right: 16px;
      }
      .modal_content_box {
        width: 100%;
        height: 100%;
        border-radius: 16px;
        background-color: black;
        .modal_video {
          width: 100%;
          height: 100%;
          border-radius: 16px;
          border: 3px solid rgba(255, 255, 255, 0.32);
        }
      }
    }
  }
`
export default WebVideoModal
